import React, { Component } from "react";
import { connect } from "react-redux";
import Table from "../table/Table";
import Paginater from "../table/Paginater";
import { getMultiStockGroupedOrders } from "../../homeActions";
import { openModal, closeModal } from "../../../modal/modalActions";

class MultiStockGroupedTab extends Component {
  state = {};

  columns = [
    {
      title: "Stock Group Id",
      dataIndex: "stock_group_id",
      sorter: (a, b) => a.stock_group_id - b.stock_group_id,
      sortDirections: ["ascend"],
      render: (text, record, index) => (
        <p
          className="validate-link"
          onClick={() =>
            this.props.openModal("MultiStockOrderListModal", {
              groupId: record.stock_group_id,
            })
          }
        >
          {text}
        </p>
      ),
      width: 250,
    },
    {
      title: "Customer",
      dataIndex: "customer.name",
      width: 500,
    },
    {
      title: "Distributor",
      dataIndex: "distributor.name",
    },
    {
      title: "Order Count",
      dataIndex: "stock_count",
    },
  ];

  render() {
    const { loading, orders, getMultiStockGroupedOrders } = this.props;
    return (
      <div>
        <Table
          rowClassName={(record, text) => {
            let end = new Date();
            let start = new Date(record.created_on);
            let hoursDiff = end.getHours() - start.getHours();
            return hoursDiff > 1 ? "highlighted-row" : "";
          }}
          columns={this.columns}
          loading={loading}
          data={(orders && orders.results) || []}
          pagination={false}
          bordered={false}
          scroll={{ x: 1300 }}
          size="middle"
        />
        <Paginater
          defaultCurrent={1}
          total={(orders && orders.count) || 0}
          onChange={getMultiStockGroupedOrders}
          pageSize={20}
        />
      </div>
    );
  }
}
const actions = {
  getMultiStockGroupedOrders,
  closeModal,
  openModal,
};
const mapStateToProps = (state) => ({
  loading: state.home.loadingMultiStockGroupedOrders,
  orders: state.home.multiStockGroupedOrders,
  activeTabKey: state.home.activeTabKey,
});
export default connect(
  mapStateToProps,
  actions
)(MultiStockGroupedTab);
